import { Button } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useTheme } from '@mui/material/styles';
import { memo } from 'react';
import Transition from './Transition';
import { Header } from './Header';
import { useTranslation } from 'react-i18next';

interface FailedDynamicDialogProps {
    isOpen: boolean;
    title: string;
    content: string;
    subContent?: string;
    onClose: () => void;
    primaryActionText?: string;
    primaryAction?: () => void;
    maxWidth?: number;
}

const FailedDynamicDialog = ({
    isOpen,
    title,
    content,
    subContent,
    onClose,
    maxWidth = 1000,
}: FailedDynamicDialogProps) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Dialog
            open={isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={(_, reason) => {
                if (reason !== 'backdropClick') onClose();
            }}
            aria-describedby="alert-dialog-slide-description"
            sx={{
                '& .MuiDialog-paper': {
                    width: '100%',
                    maxWidth,
                    backgroundColor: '#f5f5f5',
                },
            }}
        >
            <Header title={title} />
            <DialogContent>
                <DialogContentText
                    id="alert-dialog-slide-description"
                    sx={{
                        color: theme.palette.text.primary,
                        fontSize: theme.typography.body1.fontSize,
                        marginBottom: theme.spacing(1),
                        whiteSpace: 'pre-wrap',
                        wordWrap: 'break-word',
                        overflowY: 'auto',
                        maxHeight: '500px',
                    }}
                >
                    {content}
                </DialogContentText>
                {subContent && (
                    <DialogContentText
                        id="alert-dialog-slide-description-sub"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontSize: theme.typography.body2.fontSize,
                            whiteSpace: 'pre-wrap',
                            wordWrap: 'break-word',
                            overflowY: 'auto',
                            maxHeight: '200px',
                        }}
                    >
                        {subContent}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} className="button-text-color">
                    {t('CLOSE_BUTTON')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default memo(FailedDynamicDialog);